<template>
    <v-app>
        <v-toolbar app class="app-toolbar emergency">
            <v-btn :ripple="false" icon @click="$router.go(-1)">
                <v-icon class="icon-light">arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Emergency</v-toolbar-title>
        </v-toolbar>
        <v-content>
            <v-container id="document-content">
                <v-layout row>
                    <v-flex xs-12>
                        <div style="text-align: center; font-size: 16px; padding-top: 30px">
                            <span v-if="timer.progress < 100">
                                YOUR I.C.E. NUMBERS ARE BEING NOTIFIED
                            </span>
                            <span v-if="timer.progress == 100">
                                YOUR I.C.E. NUMBERS HAVE BEEN NOTIFIED
                            </span>
                        </div>

                        <div style="text-align: center; padding-top: 20px">
                            <v-progress-circular
                                    class="emergency-timer"
                                    :rotate="180"
                                    :size="100"
                                    :width="2"
                                    :value="timer.progress"
                                    color="#a00c0c"
                                    @click="cancel">

                                <span v-if="timer.progress < 100" style="font-size: 20px">CANCEL</span>

                            </v-progress-circular>
                        </div>

                        <v-card style="margin-top: 3em; border-radius: 20px">
                            <v-list two-line>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Hospital</v-list-tile-title>
                                        <v-list-tile-sub-title>10177</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action v-if="hasDialer">
                                        <v-btn round icon color="#90b636" @click="dial(10177, 'the Hospital')">
                                            <v-icon>phone</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                    <v-list-tile-action v-if="showMap">
                                        <v-btn round icon color="#597a33" @click="$router.push({name: 'authenticated.emergencymap', params: {type: 'hospital'}})">
                                            <v-icon>location_on</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-divider></v-divider>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Fire Station</v-list-tile-title>
                                        <v-list-tile-sub-title>10111</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action v-if="hasDialer">
                                        <v-btn round icon color="#90b636" @click="dial(10111, 'the Fire Station')">
                                            <v-icon>phone</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                    <v-list-tile-action v-if="showMap">
                                        <v-btn round icon color="#597a33" @click="$router.push({name: 'authenticated.emergencymap', params: {type: 'fire_station'}})">
                                            <v-icon>location_on</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-divider></v-divider>

                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Police</v-list-tile-title>
                                        <v-list-tile-sub-title>10111</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action v-if="hasDialer">
                                        <v-btn round icon color="#90b636" @click="dial(10111, 'the Police')">
                                            <v-icon>phone</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                    <v-list-tile-action v-if="showMap">
                                        <v-btn round icon color="#597a33" @click="$router.push({name: 'authenticated.emergencymap', params: {type: 'police'}})">
                                            <v-icon>location_on</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>

        <v-dialog v-model="dialer.show" :persistent="true">
            <v-card>
                <v-card-text>
                    Are you sure you want to dial {{ dialer.type }}?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn color="primary" flat @click="dialer.show = false">
                        No
                    </v-btn>

                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="executeDial()">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import vas from "@/lib/VASClient"

    export default {
        data() {
            return {
                duration: 3000,
                timer: {
                    progress: 0,
                    interval: null,
                    start: null
                },
                dialer: {
                    show: false,
                    number: null,
                    type: ''
                },
                showMap: true,
                hasDialer: false,
                position: null
            }
        },
        created() {
        },
        mounted() {
            var self = this;

            if (window.EmergencySent) {
                this.timer.progress = 100;
            } else {
                this.timer.start = new Date().getTime();

                this.timer.interval = setInterval(this.updateProgress, 50);
            }

            if (window.plugins && window.plugins.CallNumber) {
                this.hasDialer = true;
            }

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (response) {
                    self.position = response.coords;
                }, function (error) {
                    console.log(error);
                }, {});
            }
        },
        methods: {
            cancel() {
                if (this.timer.progress >= 100) {
                    return;
                }

                this.$router.go(-1);
            },
            send() {
                window.EmergencySent = true;

                var latitude = this.position == null ? null : this.position.latitude;
                var longitude = this.position == null ? null : this.position.longitude;

                vas.emergency(this.auth.user.user_id, this.auth.user.cell_no, latitude, longitude)
                    .then(function (response) {
                        console.log(response);
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
            updateProgress() {
                var current = new Date().getTime();

                var diff = current - this.timer.start;

                var percentage = Math.round((diff / this.duration) * 100);

                if (percentage > 100) {
                    percentage = 100;
                }

                this.timer.progress = percentage;

                if (percentage == 100) {
                    clearInterval(this.timer.interval);

                    this.send();
                }
            },
            dial(number, type) {
                this.dialer.type = type;
                this.dialer.number = number;
                this.dialer.show = true;
            },
            executeDial() {
                this.dialer.show = false;
                this.dialer.number = this.dialer.number;

                document.location.href = ' tel:' + this.dialer.number;
            }
        },
        computed: {
            ...mapState(
                ['auth']
            )
        }
    }
</script>